import styles from "./styles.module.css";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { IoSettings, IoLogOut, IoSunnyOutline, IoMoonOutline } from "react-icons/io5";
import SideNavBar from "../sideNavBar";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setMobSideNavBarVisibility, setTheme } from "../../../../common/actions/index";
import OutsideClickHandler from "react-outside-click-handler";
import darkLogo from "../../../../logo-contact-white.svg";

const LIGHT_LOGO_SRC =
  "https://epinics.com/static/media/logo-contact.7e2887bc289aad2327275ee13a3a4a50.svg";

const TopNavBar = ({
  logout,
  setMobSideNavBarVisibility,
  setTheme,
  common: { showMobSideNavBar },
  themeMode,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const logoSrc = themeMode === "dark" ? darkLogo : LIGHT_LOGO_SRC;


  const handleThemeToggle = () => {
    const nextMode = themeMode === "dark" ? "light" : "dark";
    setTheme(nextMode);
  };

  useEffect(() => {
    if (!menuOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const handleLogout = () => {
    setMenuOpen(false);
    logout();
    navigate("/login");
  };

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (showMobSideNavBar) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showMobSideNavBar]);

  return (
    <div className={styles.topNavBarContainer}>
      {showMobSideNavBar && (
        <div
          className={styles.mobBackdrop}
          onClick={() => setMobSideNavBarVisibility(true)}
          aria-hidden="true"
        />
      )}
      <OutsideClickHandler
        onOutsideClick={() => {
          if (showMobSideNavBar) setMobSideNavBarVisibility(true);
        }}
      >
        <div className={styles.leftDiv}>
          <button
            type="button"
            className={styles.menuIcon}
            onClick={() => setMobSideNavBarVisibility(showMobSideNavBar)}
            aria-label="Toggle menu"
          >
            <HiOutlineMenuAlt2 />
          </button>
          <div className={styles.logoDiv}>
            <img
              key={themeMode}
              src={logoSrc}
              className={styles.logoImg}
              alt="Logo"
            />
            <span>EPINICS</span>
          </div>

          <div
            className={`${styles.mobSideNavPanel} ${
              showMobSideNavBar ? styles.mobSideNavPanelShow : ""
            }`}
          >
            <div className={styles.mobDivider} />
            <SideNavBar />
          </div>
        </div>
      </OutsideClickHandler>

      <div className={styles.rightDiv} ref={menuRef}>
        <button
          type="button"
          className={styles.themeToggle}
          onClick={handleThemeToggle}
          aria-label={themeMode === "dark" ? "Switch to light theme" : "Switch to dark theme"}
        >
          {themeMode === "dark" ? (
            <IoSunnyOutline className={styles.themeToggleIcon} />
          ) : (
            <IoMoonOutline className={styles.themeToggleIcon} />
          )}
        </button>
        <button
          type="button"
          className={styles.profileButton}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-controls="account-menu"
          aria-haspopup="true"
          aria-expanded={menuOpen}
          aria-label="Account settings"
        >
          <span className={styles.avatar}>A</span>
        </button>

        <div
          id="account-menu"
          className={`${styles.accountMenu} ${menuOpen ? styles.accountMenuOpen : ""}`}
          role="menu"
        >
          <button
            type="button"
            className={styles.accountMenuItem}
            onClick={closeMenu}
            role="menuitem"
          >
            <span className={styles.avatarSmall}>A</span>
            <span className={styles.accountMenuItemText}>Profile</span>
          </button>
          <div className={styles.accountMenuDivider} />
          <button
            type="button"
            className={styles.accountMenuItem}
            onClick={closeMenu}
            role="menuitem"
          >
            <span className={styles.accountMenuIcon}>
              <IoSettings />
            </span>
            Settings
          </button>
          <button
            type="button"
            className={`${styles.accountMenuItem} ${styles.accountMenuItemDanger}`}
            onClick={handleLogout}
            role="menuitem"
          >
            <span className={styles.accountMenuIcon}>
              <IoLogOut />
            </span>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

TopNavBar.propTypes = {
  setMobSideNavBarVisibility: PropTypes.func.isRequired,
  setTheme: PropTypes.func.isRequired,
  themeMode: PropTypes.oneOf(["light", "dark"]),
};

const mapStateToProps = (state) => ({
  common: state.commonState,
  themeMode: state.theme?.mode ?? "light",
});

export default connect(mapStateToProps, { setMobSideNavBarVisibility, setTheme })(
  TopNavBar
);
